export enum IntegerType {
    BYTE = 'BYTE',
    SHORT = 'SHORT',
    INT = 'INT',
    LONG = 'LONG',
}
